import { API_MANAPAY, API_IAM, API_CONSULT } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function getCurrency() {
  return {
    types: [
      ACTION_TYPES.CURRENCY_GET_REQUESTED,
      ACTION_TYPES.CURRENCY_GET_SUCCEED,
      ACTION_TYPES.CURRENCY_GET_FAILED,
    ],
    promise: client => client.get('/currencies'),
    options: {
      clientName: API_MANAPAY,
    },
  };
}

export function getLanguage() {
  return {
    types: [
      ACTION_TYPES.LANGUAGE_GET_REQUESTED,
      ACTION_TYPES.LANGUAGE_GET_SUCCEED,
      ACTION_TYPES.LANGUAGE_GET_FAILED,
    ],
    promise: client => client.get('/languages'),
    options: {
      clientName: API_IAM,
    },
  };
}

export function getCountries() {
  return {
    types: [
      ACTION_TYPES.COUNTRIES_GET_REQUESTED,
      ACTION_TYPES.COUNTRIES_GET_SUCCEED,
      ACTION_TYPES.COUNTRIES_GET_FAILED,
    ],
    promise: client => client.get('/countries'),
    options: {
      clientName: API_IAM,
    },
  };
}

export function getPublicHolidays(params) {
  return {
    types: [
      ACTION_TYPES.GET_PUBLIC_HOLIDAY_REQUESTED,
      ACTION_TYPES.GET_PUBLIC_HOLIDAY_SUCCEED,
      ACTION_TYPES.GET_PUBLIC_HOLIDAY_FAILED,
    ],
    promise: client => client.get('/holidays', { params }),
    options: {
      clientName: API_CONSULT,
    },
  };
}
